/**
 * Returns the value for a link's target attribute based on the provided href
 *
 * Links to blog pages should open in the same tab, all other links
 * should open in a new tab
 */
export function getLinkTarget(href: string): '_blank' | '_self' {
  if (
    href.startsWith('#') ||
    href.startsWith('/blog') ||
    href.startsWith('https://zapier.com/blog') ||
    href.startsWith('https://www.zapier.com/blog')
  ) {
    return '_self';
  }

  return '_blank';
}
